import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './HeadingLabel.module.css'

export function HeadingLabel({ text }: { text?: string }) {
  if (!text) {
    return null
  }

  return <Typography className={styles.heading} variant="display-g-regular" as="h2">{text}</Typography>
}
